import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { AdminPageStyle } from "../../pages/admin/style";

export const CycleYearInfo = ({
  setYear1ValueData,
  year1ValueData,
  lg = 6,
  onChange,
  fleetTypeId,
}) => {
  const classes = AdminPageStyle();

  const changeYear = (event, data) => {
    const { checked } = event.target;
    const newData = {
      ...year1ValueData,
      [`year${data}`]: checked,
    };
    setYear1ValueData(newData);
    if (onChange) {
      onChange(newData);
    }
  };

  useEffect(() => {
    const hasAnyYearSelected =
      year1ValueData?.year1 ||
      year1ValueData?.year2 ||
      year1ValueData?.year3 ||
      year1ValueData?.year4 ||
      year1ValueData?.year5;

    if (!hasAnyYearSelected) {
      const newData = { year1: true, year2: true, year3: true, year4: true, year5: true };
      setYear1ValueData(newData);
      if (onChange) onChange(newData);
    }
  }, [fleetTypeId, year1ValueData, onChange]);

  return (
    <Grid item xs={12} sm={12} md={12} lg={lg}>
      <Accordion
        defaultExpanded
        sx={(theme) => ({
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(148,163,184,0.12)' : 'var(--divider)'}`,
          borderRadius: '16px !important',
          boxShadow: theme.palette.mode === 'dark' ? '0 8px 24px rgba(0,0,0,0.45)' : '0 8px 24px rgba(2, 6, 23, 0.06)',
          color: theme.palette.text.primary,
          '&:before': { display: 'none' },
        })}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "var(--brand-primary)" }} />}
          aria-controls="panel1-content"
          id="panel1-header"
          className={classes.textGeneralInfo}
          sx={{ borderBottom: "1px solid var(--divider)", color: "var(--brand-primary)" }}
        >
          cycle year information
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 2 }}>
          <Box>
            <Box>
              <Box className={classes.divMt10}>
                <Box className={classes.fleetListGenInfoDiv}>
                  <span className={classes.fleetListTotalMileageText}>
                    Year 1
                  </span>
                  <span className={classes.fleetListGenInfoTtext}>
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={year1ValueData?.year1 ? true : false}
                          onChange={(e) => changeYear(e, 1)}
                        />
                      }
                    />
                  </span>
                </Box>
              </Box>
              <Box className={classes.divMt10}>
                <Box className={classes.fleetListGenInfoDiv}>
                  <span className={classes.fleetListTotalMileageText}>
                    Year 2
                  </span>
                  <span className={classes.fleetListGenInfoTtext}>
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={year1ValueData?.year2 ? true : false}
                          onChange={(e) => changeYear(e, 2)}
                        />
                      }
                    />
                  </span>
                </Box>
              </Box>
              <Box className={classes.divMt10}>
                <Box className={classes.fleetListGenInfoDiv}>
                  <span className={classes.fleetListTotalMileageText}>
                    Year 3
                  </span>
                  <span className={classes.fleetListGenInfoTtext}>
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={year1ValueData?.year3 ? true : false}
                          onChange={(e) => changeYear(e, 3)}
                        />
                      }
                    />
                  </span>
                </Box>
              </Box>
              <Box className={classes.divMt10}>
                <Box className={classes.fleetListGenInfoDiv}>
                  <span className={classes.fleetListTotalMileageText}>
                    Year 4
                  </span>
                  <span className={classes.fleetListGenInfoTtext}>
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={year1ValueData?.year4 ? true : false}
                          onChange={(e) => changeYear(e, 4)}
                        />
                      }
                    />
                  </span>
                </Box>
              </Box>
              <Box className={classes.divMt10}>
                <Box className={classes.fleetListGenInfoDiv}>
                  <span className={classes.fleetListTotalMileageText}>
                    Year 5
                  </span>
                  <span className={classes.fleetListGenInfoTtext}>
                    <FormControlLabel
                      control={
                        <Switch
                          size="small"
                          checked={year1ValueData?.year5 ? true : false}
                          onChange={(e) => changeYear(e, 5)}
                        />
                      }
                    />
                  </span>
                </Box>
              </Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
